export const LocalStorageKeys = Object.freeze({
  FUNNEL: 'funnel',
  INDUSTRY: 'ssu-industry',
  NAME: 'ssu-name',
  WHAT_BROUGHT_YOU: 'ssu-what-brought-you',
  NUM_OF_EMPLOYEES: 'ssu-numOfEmployees',
  PAGE_REGISTERED_ON: 'page-registered-on',
  PLAN: 'ssu-plan',
  ZIP: 'ssu-zip',
  HR_MANAGER: 'ssu-hrm',
  COMPANY_ID: 'company-id',
  PHONE: 'phone',
  USER_ID: 'user',
});

export const SelfServicePageSlugs = Object.freeze({
  WHAT_BROUGHT_YOU: 'what-brought-you',
  COMPANY_SIZE: 'company-size',
  COMPANY_NAME: 'company-name',
  ZIP_CODE: 'zip-code',
  INDUSTRY: 'industry',
  CONTACT_INFO: 'contact-info',
  PAYMENT: 'payment',
  // Post-purchase (BIO-2149): coverage level, the level's plans, how installation
  // works, and the founder installation call.
  HANDOFF: 'handoff',
  PLANS: 'plans',
  INSTALLATION: 'installation',
  SCHEDULE: 'schedule',
});

export const tiersThatGetSentToSelfService = [1, 2, 3, 4, 5, 6, 7];

export const SelfServicePreRegistrationPages = Object.freeze([
  { slug: SelfServicePageSlugs.WHAT_BROUGHT_YOU },
  { slug: SelfServicePageSlugs.COMPANY_SIZE },
  { slug: SelfServicePageSlugs.COMPANY_NAME },
  { slug: SelfServicePageSlugs.ZIP_CODE },
  { slug: SelfServicePageSlugs.INDUSTRY },
  { slug: SelfServicePageSlugs.CONTACT_INFO },
]);

// IMPORTANT: the last page in this array triggers flow completion
// (handleCompleteLeadConversion in pages/SelfService.vue). SCHEDULE submits once the
// founder call is booked or deferred.
export const SelfServicePostRegistrationPages = Object.freeze([
  { slug: SelfServicePageSlugs.PAYMENT },
  { slug: SelfServicePageSlugs.HANDOFF },
  { slug: SelfServicePageSlugs.PLANS },
  { slug: SelfServicePageSlugs.INSTALLATION },
  { slug: SelfServicePageSlugs.SCHEDULE },
]);

const SelfServicePages = Object.freeze([
  ...SelfServicePreRegistrationPages,
  ...SelfServicePostRegistrationPages,
]);

export default SelfServicePages;
